import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function useContent(pageKey, fallback = {}) {
  const [content, setContent] = useState(fallback);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetch = async () => {
      try {
        const r = await axios.get(`${BACKEND_URL}/api/content/${pageKey}`);
        if (!cancelled) setContent(r.data);
      } catch {
        // Keep fallback
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetch();
    return () => { cancelled = true; };
  }, [pageKey]);

  return { content, loading };
}
